import { createLead } from '../../../utils/common-lead-apis';
import { setUTMParamInCookie } from '../../../utils/cookieUtils';
import { ISEND_GATED_ASSET_DATA } from '../../Common/GatedAsset/utils';
import { IPartnerPlanData } from '../../partner-pages/types';
import {
  TCategoryPlanMapping,
  TMeta,
  TPlanCategory,
  TPricingPlans,
} from './types';

export const getObjectByKey = (
  objects: TMeta[],
  key: string
): TMeta | undefined => {
  return objects.find((obj) => obj.key === key);
};

export const createId = (text: string): string => {
  // replace all non-word characters with underscores
  const id = text.replace(/\W+/g, '_').toLowerCase();
  return id;
};

export const mapCategoryPlans = (
  categoryArray: TPlanCategory[],
  categoryDataArray: TPricingPlans[]
): TCategoryPlanMapping => {
  const categoryDataMap = new Map(
    categoryDataArray
      .filter((item) => item)
      .map((item) => [item.planDetails.planId, item])
  );

  const result: TCategoryPlanMapping = {};

  categoryArray.forEach((category) => {
    result[createId(category.name)] = category.plans.map((plan) =>
      categoryDataMap.get(plan.plan_id)
    ) as unknown as TPricingPlans[];
  });

  return result;
};

export const getPlanDataWithCoupons = (
  planData: TPricingPlans[]
): IPartnerPlanData[] => {
  const result: IPartnerPlanData[] = [];
  planData.forEach((plan) => {
    if (!plan) return;
    result.push({
      planDetails: plan.planDetails,
      coupon: plan.autoApplicableCoupon,
      partnerSlug: '',
    });
  });
  return result;
};

export const getCategoryMappingWCoupon = (
  categoryMapping: TCategoryPlanMapping
): { [key: string]: IPartnerPlanData[] } => {
  const result: { [key: string]: IPartnerPlanData[] } = {};
  Object.keys(categoryMapping).forEach((categoryKey) => {
    const categoryPlans: IPartnerPlanData[] = [];
    categoryMapping[categoryKey]?.forEach((plan) => {
      if (!plan) return;
      categoryPlans.push({
        planDetails: plan.planDetails,
        coupon: plan.autoApplicableCoupon,
        partnerSlug: '',
      });
    });
    result[categoryKey] = categoryPlans;
  });

  return result;
};

export const sendPricingPageLead = ({
  formData,
  token,
}: ISEND_GATED_ASSET_DATA): Promise<string> => {
  if (typeof window === 'undefined') {
    return Promise.reject('Window does not exist');
  }
  setUTMParamInCookie(window.location.search);
  return createLead(
    {
      lead_data: {
        ...formData,
      },
      lead_platforms: {
        lsq: {},
      },
    },
    token
  );
};
